import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Danger from "components/Typography/Danger.js";
import Button from "components/CustomButtons/Button.js";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

export default function ImageUpload(props) {
  const [file, setFile] = React.useState(null);
  const [error, setError] = React.useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.avatar ? defaultAvatar : defaultImage
  );
  React.useEffect(() => {
    if (props.initialDataProps) {
      setImagePreviewUrl(props.initialDataProps.logo);
    }
  }, []);
  React.useEffect(() => {
    //console.log(props.clearFileValue);
    if (props.clearFileValue) {
      //console.log("Executing First Time");
      setFile(null);
      setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
      props.setClearFileValueProps();
    }
  }, [props.clearFileValue]);

  let fileInput = React.createRef();
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      if (file && file["type"].split("/")[0] === "image") {
        setError(false);
        setFile(file);
        setImagePreviewUrl(reader.result);
        if (props.keyProps) {
          props.setFileProps(file, props.keyProps);
        } else {
          props.setFileProps(file);
        }
      } else {
        setError(true);
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setError(true);
    }
  };
  // eslint-disable-next-line
  const handleSubmit = (e) => {
    e.preventDefault();
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    props.setFileProps(null);
    setFile(null);
    setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;
  };
  let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;
  return (
    <div className="fileinput text-center">
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
        <img src={imagePreviewUrl} alt="..." />
      </div>
      {error ? <Danger style={{ textAlign: "center" }}>This is not an image file!</Danger> : ""}
      <div>
        {file === null ? (
          <Button {...addButtonProps} onClick={() => handleClick()}>
            {avatar ? "Add Photo" : "Select image"}
          </Button>
        ) : (
          <span>
            <Button {...changeButtonProps} onClick={() => handleClick()}>
              Change
            </Button>
            {avatar ? <br /> : null}
            <Button {...removeButtonProps} onClick={() => handleRemove()}>
              <i className="fas fa-times" /> Remove
            </Button>
          </span>
        )}
      </div>
    </div>
  );
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
